import { useContext } from "react";
import { SelectableTextContext, WebEditorContext } from "../../../../contexts";
import _ from "lodash";
import * as Constants from "../../../../utils/constants";
import TextHoverComponent from "./TextHoverComponent";

export default function TextChoiceComponent({ editorTextChoice, filter, inSidebarDialog }) {
    const { selectedTextPartIdRef, setHoveredSelectableText } = useContext(SelectableTextContext);
    const { autoSaveEditorFile, formikValuesRef, onInputFieldChange } = useContext(WebEditorContext);

    const getInputId = (editorTextPart) => {
        return `${inSidebarDialog ? 'dialog-' : ''}predefined-input-${editorTextPart.Id}`;
    }

    const handleRadioGroupChange = async (editorTextPart) => {
        editorTextChoice.Items.forEach(textPart => {
            if (textPart.Id === editorTextPart.Id) {
                onInputFieldChange({
                    target: {
                        name: textPart.Id,
                        value: true,
                    }
                });
                textPart.Visible = true;
                formikValuesRef.current[textPart.Id] = true;
            } else {
                onInputFieldChange({
                    target: {
                        name: textPart.Id,
                        value: false,
                    }
                });
                textPart.Visible = false;
                formikValuesRef.current[textPart.Id] = false;
            }
        })

        selectedTextPartIdRef.current = editorTextPart.Id;

        autoSaveEditorFile();
    }

    const handleCheckBoxChange = async (editorTextPart, visible) => {
        editorTextPart.Visible = visible;
        onInputFieldChange({
            target: {
                name: editorTextPart.Id,
                value: visible,
            }
        });
        formikValuesRef.current[editorTextPart.Id] = visible;
        
        if (visible) {
            selectedTextPartIdRef.current = editorTextPart.Id;
        } else {
            selectedTextPartIdRef.current = null;

            setHoveredSelectableText(null);
        }

        autoSaveEditorFile();
    }

    const visibleItems = () => {
        let itemsWithFilter = [];

        // if(filter?.search !== "") {
        editorTextChoice.Items.forEach((item) => {
            item.Keywords = item.Keywords || [];

            let checkOnNoKeyword = item.Keywords?.length === 0 && filter.keywords.includes("<Blanke>");
            let hasKeyWord = checkOnNoKeyword || item.Keywords?.some(k => filter.keywords.includes(k));

            if (item.Description.toLowerCase().includes(filter.search.toLowerCase()) && hasKeyWord) {
                itemsWithFilter.push(item);
            }
        })

        // let itemsWithFilter = filter?.search === "" ? editorTextChoice.Items : editorTextChoice.Items.filter(item => item.Description.toLowerCase().includes(filter.search.toLowerCase()));

        // let checkOnNoKeyword = editorTextPart.Keywords.length === 0 && filter.keywords.includes("<Blanke>");
        // let hasKeyWord = checkOnNoKeyword || editorTextPart.Keywords.some(k => filter.keywords.includes(k));
        // }
        // else {
        //     itemsWithFilter = editorTextChoice.Items;
        // }

        return itemsWithFilter || [];
    }

    const isVisible = () => {
        return editorTextChoice?.Description?.toLowerCase().includes(filter?.search?.toLowerCase()) || visibleItems().length > 0
    }

    const handleMouseEnter = (editorTextPart) => {
        selectedTextPartIdRef.current = null;

        if (editorTextChoice.IsRadioGroupMode) {
            const clonedEditorTextChoice = _.cloneDeep(editorTextChoice);
            clonedEditorTextChoice.Items.forEach(x => {
                if (x.Type === Constants.editorType.textPart) {
                    x.Visible = false;
                }
            })

            const clonedEditorTextPart = clonedEditorTextChoice.Items.find(x => x.Id === editorTextPart.Id);
            if (clonedEditorTextPart) {
                clonedEditorTextPart.Visible = true;
            }

            setHoveredSelectableText(clonedEditorTextChoice);
        } else {
            const clonedEditorTextPart = _.cloneDeep(editorTextPart);
            clonedEditorTextPart.Visible = true;
            setHoveredSelectableText(clonedEditorTextPart);
        }
    }

    const handleMouseLeave = () => {
        setHoveredSelectableText(null);
    }

    return (
        isVisible() &&
        <div className="tw-border tw-rounded-md tw-shadow-sm">
            <div className="tw-flex-1 tw-py-2 tw-px-3 sm:tw-px-6 tw-overflow-x-hidden tw-break-words tw-text-gray-900 tw-text-sm tw-font-medium">{editorTextChoice.Description}</div>
            <div className="tw-px-1 sm:tw-px-4 tw-py-1">
                {visibleItems().map((editorTextPart) => (
                    <TextHoverComponent
                        key={editorTextPart.Id}
                        cssClass="tw-relative tw-px-2 tw-py-2 tw-flex tw-rounded hover:tw-bg-gray-200 "
                        onMouseEnter={() => handleMouseEnter(editorTextPart)}
                        onMouseLeave={() => handleMouseLeave()}
                    >
                        {
                            (editorTextChoice.IsRadioGroupMode)
                                ?
                                (
                                    <>
                                        <div className="tw-flex tw-items-center tw-h-5">
                                            <input
                                                id={getInputId(editorTextPart)}
                                                name={`predefined-input-name-${editorTextChoice.Id}`}
                                                type="radio"
                                                className="focus:tw-ring-indigo-700 tw-h-4 tw-w-4 tw-text-indigo-700 tw-cursor-pointer tw-border-gray-300"
                                                checked={editorTextPart.Visible}
                                                onChange={() => handleRadioGroupChange(editorTextPart)}
                                            />
                                        </div>
                                        <label
                                            htmlFor={getInputId(editorTextPart)}
                                            className="tw-ml-3 tw-w-full tw-flex tw-flex-col tw-cursor-pointer tw-text-gray-900 tw-text-sm tw-font-medium tw-overflow-x-hidden tw-break-words"
                                            onClick={(e) => handleRadioGroupChange(editorTextPart)}
                                        >
                                            {editorTextPart.Description}
                                        </label>
                                    </>
                                )
                                :
                                (
                                    <>
                                        <div className="tw-flex tw-items-center tw-h-5">
                                            <input
                                                id={getInputId(editorTextPart)}
                                                name={`input-${getInputId(editorTextPart)}`}
                                                type="checkbox"
                                                className="focus:tw-ring-indigo-700 tw-h-4 tw-w-4 tw-text-indigo-700 tw-cursor-pointer tw-border-gray-300"
                                                checked={editorTextPart.Visible}
                                                onChange={(e) => handleCheckBoxChange(editorTextPart, e.target.checked)}
                                            />
                                        </div>
                                        <label
                                            htmlFor={`input-${getInputId(editorTextPart)}`}
                                            className="tw-ml-3 tw-flex tw-flex-col tw-cursor-pointer tw-text-gray-900 tw-text-sm tw-font-medium tw-overflow-x-hidden tw-break-words"
                                            onClick={(e) => handleCheckBoxChange(editorTextPart, _.clone(!editorTextPart.Visible))}
                                        >
                                            {editorTextPart.Description}
                                        </label>
                                    </>
                                )

                        }
                    </TextHoverComponent>
                ))}
            </div>
        </div>
    )
}
